import { createSlice } from "@reduxjs/toolkit";

const {
  actions: {
    getVoucherCodesStart,
    getVoucherCodesSuccess,
    getVoucherCodesFailure,
    createVoucherCodeStart,
    createVoucherCodeFailure,
    createVoucherCodeSuccess,
    updateVoucherCodeStart,
    updateVoucherCodeSuccess,
    updateVoucherCodeFailure,
    updateVoucherCodeOptimistic,
    deleteVoucherCodeStart,
    deleteVoucherCodeSuccess,
    deleteVoucherCodeFailure,
  },
  reducer,
} = createSlice({
  name: "voucherCodes",
  initialState: {
    loading: false,
    voucherCodes: null,
  },
  reducers: {
    getVoucherCodesStart: (state) => ({
      ...state,
      loading: true,
    }),
    getVoucherCodesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      voucherCodes: payload,
    }),
    getVoucherCodesFailure: (state) => ({
      ...state,
      loading: false,
    }),
    createVoucherCodeStart: (state) => ({
      ...state,
      loading: true,
    }),
    createVoucherCodeSuccess: (state) => ({
      ...state,
      loading: false,
    }),
    createVoucherCodeFailure: (state) => ({
      ...state,
      loading: false,
    }),
    updateVoucherCodeStart: (state) => ({
      ...state,
    }),
    updateVoucherCodeSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
    }),
    updateVoucherCodeFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      voucherCodes: state.voucherCodes
        ? {
            ...state.voucherCodes,
            data: state.voucherCodes.data.map((code) => {
              if (code.voucherCodeId !== payload.voucherCodeId) return code;

              // Revert status and/or isRedeemed based on what we changed optimistically
              return {
                ...code,
                ...(typeof payload.previousStatus !== "undefined" && {
                  status: payload.previousStatus,
                }),
                ...(typeof payload.previousIsRedeemed !== "undefined" && {
                  isRedeemed: payload.previousIsRedeemed,
                }),
              };
            }),
          }
        : null,
    }),
    updateVoucherCodeOptimistic: (state, { payload }) => ({
      ...state,
      voucherCodes: state.voucherCodes
        ? {
            ...state.voucherCodes,
            data: state.voucherCodes.data.map((code) => {
              if (code.voucherCodeId !== payload.voucherCodeId) return code;

              return {
                ...code,
                ...(typeof payload.newStatus !== "undefined" && {
                  status: payload.newStatus,
                }),
                ...(typeof payload.newIsRedeemed !== "undefined" && {
                  isRedeemed: payload.newIsRedeemed,
                }),
              };
            }),
          }
        : null,
    }),
    deleteVoucherCodeStart: (state) => ({
      ...state,
      loading: true,
    }),
    deleteVoucherCodeSuccess: (state) => ({
      ...state,
      loading: false,
    }),
    deleteVoucherCodeFailure: (state) => ({
      ...state,
      loading: false,
    }),
  },
});

export default reducer;

export {
  getVoucherCodesStart,
  getVoucherCodesSuccess,
  getVoucherCodesFailure,
  createVoucherCodeStart,
  createVoucherCodeFailure,
  createVoucherCodeSuccess,
  updateVoucherCodeStart,
  updateVoucherCodeSuccess,
  updateVoucherCodeFailure,
  updateVoucherCodeOptimistic,
  deleteVoucherCodeStart,
  deleteVoucherCodeSuccess,
  deleteVoucherCodeFailure,
};
